import { render, staticRenderFns } from "./deliveryReport.vue?vue&type=template&id=370b7626&scoped=true"
import script from "./deliveryReport.vue?vue&type=script&lang=js"
export * from "./deliveryReport.vue?vue&type=script&lang=js"
import style0 from "./deliveryReport.vue?vue&type=style&index=0&id=370b7626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b7626",
  null
  
)

export default component.exports